module.exports = __webpack_public_path__ + "static/media/text.3c2aaa82.svg";